import React from "react";
import PropTypes from "prop-types";
import BeatLoader from "react-spinners/BeatLoader";

import css from "./LoadingIndicator.module.scss";

const LoadingIndicator = ({
  colour = "light",
  size = "small",
  style = {}
}) => {
  const loaderColor = colour === "dark" ? "#222222" : "#838586";
  const loaderSize = size === "large" ? 18 : 10;

  return (
    <div className={css.beatLoader} role="status" style={style}>
      <BeatLoader
        color={loaderColor}
        size={loaderSize}
        speedMultiplier={0.8}
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

LoadingIndicator.propTypes = {
  colour: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["small", "large"]),
  style: PropTypes.any
};

LoadingIndicator.defaultProps = {
  colour: "light",
  size: "small",
  style: {}
};

export default LoadingIndicator;
